import { isCurrentView, togglePassword } from "../../../shared/utils/view-util";

function loadRecaptcha() {
  const v2_element = document.getElementById("grecaptcha_v2_token");
  if (v2_element) {
    grecaptcha.render(v2_element.id, {
      sitekey: v2_element.getAttribute("site-key"),
    });
  } else {
    const v3_element = document.getElementById("grecaptcha_v3_token");
    grecaptcha
      .execute(v3_element.getAttribute("site-key"), { action: "sign_up" })
      .then((token) => v3_element.setAttribute("value", token));
  }
}

// Expose for reCAPTCHA callback
window.loadRecaptcha = loadRecaptcha;

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.registrations")) {
    return;
  }

  const userPassword = document.getElementById("user_password");
  const userPasswordWrapper = document.getElementById("password_wrapper");
  togglePassword(userPassword, userPasswordWrapper);

  $("#user_lead_attributes_contact_number").on("input", function (e) {
    if (e && e.target && e.target.value) {
      e.target.value = e.target.value.replace(/\s+/g, "");
    }
  });

  const form = document.getElementById("new_user");
  const referralSourceSelect = document.getElementById(
    "user_lead_attributes_referral_source",
  );
  const referralSourceDetail = document.getElementById(
    "user_lead_attributes_referral_source_detail",
  );
  const referralSourceDetailWrapper = document.getElementById(
    "referral_source_detail_wrapper",
  );
  // window.$ is Sprockets' jQuery (with Bootstrap plugins); Webpacker's $ lacks them
  const warningModal = (window.$ || $)("#gameGamblingModal");
  const formSubmitButton = document.getElementById("submit_button");
  const modalSubmitButton = document.getElementById("continue-submit");
  const modalCancelButton = document.getElementById("cancel-submit");
  const formSubmitButtonOriginalState = formSubmitButton.innerHTML;
  let shouldSubmit = false;

  function toggleReferralSourceDetail() {
    const selectedValue = referralSourceSelect.value;
    if (selectedValue === "game_or_gambling" || selectedValue === "other") {
      referralSourceDetailWrapper.style.display = "";
    } else {
      referralSourceDetailWrapper.style.display = "none";
      referralSourceDetail.value = "";
    }
  }

  toggleReferralSourceDetail();
  referralSourceSelect.addEventListener("change", toggleReferralSourceDetail);

  form.addEventListener("submit", function (e) {
    if (!shouldSubmit && referralSourceSelect.value === "game_or_gambling") {
      e.preventDefault();
      warningModal.modal("show");
    }
  });

  modalSubmitButton.addEventListener("click", function () {
    shouldSubmit = true;
    warningModal.modal("hide");
    form.submit();
  });

  modalCancelButton.addEventListener("click", function () {
    shouldSubmit = false;
    warningModal.modal("hide");
  });

  warningModal.on("hidden.bs.modal", function () {
    if (!shouldSubmit) {
      formSubmitButton.disabled = false;
      formSubmitButton.innerHTML = formSubmitButtonOriginalState;
    }
  });
});
